// extracted by mini-css-extract-plugin
export default {"body":"ForgottenPassword_body__iDCHi"};